module.exports = __webpack_public_path__ + "9ce17218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_phone.png
// module id = 567
// module chunks = 0 1 2 3 4 5